export const initialState = {
	chartsSettings: {}
};

export default { initialState };
